/**
 * Avatar — round user image.
 *
 * Shows the Microsoft profile photo (pulled from Graph on login → user.photoUrl)
 * when available; otherwise initials on a neutral grey (#E6E8EC) with brand-teal
 * (#0D9488) text. Always round. See styles/global.css → .avatar.
 */
import React from 'react';

export default function Avatar({ photoUrl, initials = '?', size, className = '', style }) {
  const dim = size ? { width: size, height: size } : undefined;
  const cls = `avatar${className ? ' ' + className : ''}`;
  if (photoUrl) {
    return <img className={cls} src={photoUrl} alt="" style={{ ...dim, ...style }} />;
  }
  return <div className={cls} style={{ ...dim, ...style }}>{initials}</div>;
}
